(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pneuma-charm-bar"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root){
      if(!root||root.dataset.pcbInitialized==='true')return;
      root.dataset.pcbInitialized='true';
      var builder=root.querySelector('[data-pcb-builder]');
      var imageData=document.querySelector('[data-pcb-images="'+root.dataset.pneumaCharmBar+'"]');
      var images=imageData?JSON.parse(imageData.textContent):{};
      var media=root.querySelector('[data-pcb-media]');
      var hero=media?media.querySelector('.pcb-stage__image'):null;
      var previewLabel=root.querySelector('[data-pcb-preview-label]');
      var summaryPiece=root.querySelector('[data-pcb-summary-piece]');
      var summaryFinish=root.querySelector('[data-pcb-summary-finish]');
      var summaryCharms=root.querySelector('[data-pcb-summary-charms]');
      var selectionList=root.querySelector('[data-pcb-selection-list]');
      var count=root.querySelector('[data-pcb-count]');
      var live=root.querySelector('[data-pcb-live]');
      var state={piece:'necklace',pieceLabel:'',finish:'gold',finishLabel:'',charms:[]};
      builder.querySelectorAll('[data-pcb-choice]').forEach(function(button){
        var group=button.dataset.group;
        if(button.getAttribute('aria-pressed')==='true'){
          state[group]=button.dataset.value;
          state[group+'Label']=button.dataset.label;
        }
        button.addEventListener('click',function(){
          builder.querySelectorAll('[data-pcb-choice][data-group="'+group+'"]').forEach(function(choice){choice.classList.remove('is-active');choice.setAttribute('aria-pressed','false');});
          button.classList.add('is-active');button.setAttribute('aria-pressed','true');
          state[group]=button.dataset.value;state[group+'Label']=button.dataset.label;
          if(group==='finish'){updatePieceThumbnails();updateCharmFinishes();}
          updateHero();updateSummary();
        });
      });

      builder.querySelectorAll('[data-pcb-charm]').forEach(function(button){
        if(button.getAttribute('aria-pressed')==='true')state.charms.push(charmData(button));
        button.addEventListener('click',function(){
          var index=state.charms.findIndex(function(item){return item.button===button;});
          if(index>-1){state.charms.splice(index,1);button.classList.remove('is-active');button.setAttribute('aria-pressed','false');}
          else{
            state.charms.push(charmData(button));button.classList.add('is-active');button.setAttribute('aria-pressed','true');
          }
          renderSelection();updateSummary();
        });
      });

      function charmData(button){return{button:button,label:button.dataset.label,goldImage:button.dataset.goldImage||'',silverImage:button.dataset.silverImage||button.dataset.goldImage||''};}
      function charmImage(item){return state.finish==='silver'?(item.silverImage||item.goldImage):item.goldImage;}
      function updateHero(){
        if(!hero||!images[state.piece]||!images[state.piece][state.finish])return;
        media.classList.add('is-changing');
        var next=images[state.piece][state.finish];
        var preload=new Image();
        preload.onload=function(){
          /* image_tag renders a responsive srcset for the initial necklace.
             Remove it before swapping src, otherwise the browser keeps choosing
             the original necklace candidate even after Bracelet is selected. */
          hero.removeAttribute('srcset');
          hero.removeAttribute('sizes');
          hero.src=next;
          hero.alt=state.pieceLabel+' · '+state.finishLabel;
          requestAnimationFrame(function(){media.classList.remove('is-changing');});
        };
        preload.src=next;
      }
      function updatePieceThumbnails(){
        builder.querySelectorAll('.pcb-piece__media img').forEach(function(img){var src=img.dataset[state.finish+'Src'];if(src)img.src=src;});
      }
      function updateCharmFinishes(){
        builder.querySelectorAll('[data-pcb-charm]').forEach(function(button){var img=button.querySelector('[data-pcb-charm-image]');var src=state.finish==='silver'?(button.dataset.silverImage||button.dataset.goldImage):button.dataset.goldImage;if(img&&src){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=src;}});
        renderSelection();
      }
      function renderSelection(){
        if(!selectionList)return;
        selectionList.innerHTML='';
        state.charms.forEach(function(item){
          var token=document.createElement('span');token.className='pcb-selected';
          var source=charmImage(item);if(source){var img=document.createElement('img');img.src=source;img.alt=item.label;token.appendChild(img);}
          var name=document.createElement('b');name.textContent=item.label;token.appendChild(name);selectionList.appendChild(token);
        });
      }
      function updateSummary(){
        if(summaryPiece)summaryPiece.textContent=state.pieceLabel;
        if(summaryFinish)summaryFinish.textContent=state.finishLabel;
        if(summaryCharms)summaryCharms.textContent=state.charms.length?state.charms.map(function(item){return item.label;}).join(', '):'—';
        if(previewLabel)previewLabel.textContent=state.pieceLabel+' · '+state.finishLabel;
        if(count)count.textContent=String(state.charms.length);
        if(live)live.textContent=state.pieceLabel+', '+state.finishLabel+'. '+state.charms.map(function(item){return item.label;}).join(', ');
      }
      updateCharmFinishes();updateSummary();
    }

    function reveal(root){
      var items=root.querySelectorAll('.pcb-reveal');
      if(reduceMotion||!('IntersectionObserver' in window)){items.forEach(function(item){item.classList.add('is-visible');});return;}
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{rootMargin:'0px 0px -8%',threshold:.12});
      items.forEach(function(item){observer.observe(item);});
    }
    function initAll(scope){(scope||document).querySelectorAll('[data-pneuma-charm-bar]').forEach(function(root){init(root);reveal(root);});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});else initAll(document);
    document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pneuma-home"] && !Shopify.designMode) return;
  try {
    
  class PneumaExperience extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.setupIntro();
      this.setupReveals();
      if (!this.reducedMotion) this.setupTilt();
    }

    setupIntro() {
      const intro = this.querySelector('[data-intro]');
      if (!intro) return;
      const mobileViewport = window.matchMedia('(max-width: 47.99rem)').matches;
      const video = intro.querySelector(`[data-intro-video="${mobileViewport ? 'mobile' : 'desktop'}"]`);
      const params = new URLSearchParams(window.location.search);
      const force = params.get('pneuma_intro') === '1';
      let seen = false;
      try { seen = sessionStorage.getItem('pneuma-v2-intro'); } catch { seen = false; }
      if (seen && !force) return;
      intro.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const close = () => {
        if (intro.classList.contains('is-revealing')) return;
        intro.classList.add('is-revealing');
        try { sessionStorage.setItem('pneuma-v2-intro', '1'); } catch {}
        window.setTimeout(() => {
          intro.hidden = true;
          document.documentElement.style.overflow = '';
        }, 1200);
      };
      if (this.reducedMotion) {
        window.setTimeout(close, 50);
        return;
      }
      if (video) {
        video.currentTime = 0;
        const play = video.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
        const revealAtEnd = () => {
          if (video.currentTime >= 4.85) close();
        };
        video.addEventListener('timeupdate', revealAtEnd);
        video.addEventListener('ended', close, { once: true });
      }
      window.setTimeout(close, 5600);
    }

    setupReveals() {
      const items = this.querySelectorAll('[data-reveal]');
      if (this.reducedMotion || !('IntersectionObserver' in window)) {
        for (const item of items) item.classList.add('is-visible');
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
      for (const item of items) observer.observe(item);
    }

    setupTilt() {
      for (const item of this.querySelectorAll('[data-tilt]')) {
        item.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;
          const rect = item.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width - 0.5;
          const y = (event.clientY - rect.top) / rect.height - 0.5;
          item.style.transform = `rotateX(${y * -5}deg) rotateY(${x * 7}deg) translateZ(0)`;
        });
        item.addEventListener('pointerleave', () => { item.style.transform = ''; });
      }
    }
  }
  if (!customElements.get('pneuma-experience')) customElements.define('pneuma-experience', PneumaExperience);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pneuma-signature-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
scope.querySelectorAll('[data-pn-divider]').forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(el);
        el.dataset.revealed = 'true';
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        el.querySelector('.pn-light-divider__beam').animate([
          {transform:'scaleX(0)',opacity:0},
          {transform:'scaleX(.08)',opacity:1,offset:.12},
          {transform:'scaleX(1)',opacity:1,offset:.72},
          {transform:'scaleX(1)',opacity:0}
        ], {duration:1500,easing:'cubic-bezier(.25,.6,.3,1)'});
      }), {threshold:.8});
      observer.observe(el);
    });
    scope.querySelectorAll('[data-pn-seals]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-seal-track]');
      const items = [...root.querySelectorAll('[data-seal]')];
      const buttons = [...root.querySelectorAll('[data-seal-index]')];
      const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
      buttons.forEach((button, index) => button.addEventListener('click', (event) => {
        track.scrollTo({left:items[index].offsetLeft-items[0].offsetLeft,behavior:reduced() || event.detail===0?'instant':'smooth'});
      }));
      let frame = 0;
      track.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const index = Math.max(0,Math.min(2,Math.round(track.scrollLeft/track.clientWidth)));
          buttons.forEach((button, i) => {if(i===index)button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');});
        });
      }, {passive:true});
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (reduced()) return;
        const item = entry.target;
        const mobile = matchMedia('(max-width:749px)').matches;
        const delay = mobile?0:items.indexOf(item)*90;
        const kind = item.dataset.seal;
        const from = kind==='truck'?'translateX(-18px)':kind==='gift'?'translateY(10px) rotate(-7deg)':'translateY(-9px) rotate(3deg)';
        item.querySelector('img').animate([{opacity:0,transform:from},{opacity:1,transform:'translate(0) rotate(0deg)'}],{duration:850,delay,easing:'cubic-bezier(.23,1,.32,1)',fill:'backwards'});
        item.querySelector('p').animate([{opacity:0,transform:'translateY(6px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay:delay+100,easing:'cubic-bezier(.23,1,.32,1)',fill:'backwards'});
      }), {threshold:.55});
      items.forEach((item) => observer.observe(item));
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pneuma-solo-cristo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.pscReady === 'true') return;
      root.dataset.pscReady = 'true';
      const items = root.querySelectorAll('[data-psc-reveal]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cross = root.querySelector('.pneuma-solo-cristo__cross');
      if (cross && window.matchMedia('(hover: hover)').matches) {
        cross.addEventListener('pointerenter', () => root.classList.add('is-lit'));
        cross.addEventListener('pointerleave', () => root.classList.remove('is-lit'));
      }
      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      items.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('[data-pneuma-solo-cristo]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-pneuma-solo-cristo]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pneuma-story-editorial"]) return;
  try {
    
(function(){
function init(scope){scope.querySelectorAll('[data-pn-narrative]').forEach(function(root){
if(root.dataset.ready)return;root.dataset.ready='true';root.classList.add('is-enhanced');
var buttons=Array.from(root.querySelectorAll('[data-story-language]')),panels=Array.from(root.querySelectorAll('[data-story-copy]'));root.querySelector('.pn-narrative__languages').hidden=false;
function select(lang){buttons.forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.storyLanguage===lang));});panels.forEach(function(panel){panel.hidden=panel.dataset.storyCopy!==lang;});}
buttons.forEach(function(button){button.addEventListener('click',function(){select(button.dataset.storyLanguage);});});select('en');
var reveal=root.querySelector('[data-story-reveal]');if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){reveal.classList.add('will-reveal');var observer=new IntersectionObserver(function(entries){if(entries.some(function(entry){return entry.isIntersecting;})){reveal.classList.add('is-visible');observer.disconnect();}},{threshold:.1});observer.observe(reveal);}
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
